import React, { useEffect } from "react";
import { renderButton, renderTextField, renderCancelButton, renderCheckField, renderRadioField, renderTextAreaField} from "@/shared/FormUtils";
import { fetchAPI } from "@/utility/NetworkUtils";
import Loading from "@/shared/Loading";
import { Stack } from "@mui/material";
import { isJaguar } from "@/utility/UserUtils";
import ReceivingListTrackingNumberForm from "../ReceivingListTrackingNumberForm";
import ItemHoldFormRevised from "../ItemHoldFormRevised";
const ItemAddForm = ({
  formikProps,
  item,
  onClose,
  onSave,
  user,
  open
}) => {
  const [ upcomingEvents, setUpcomingEvents ] = React.useState(null);
  const [ submitting, setSubmitting ] = React.useState(false);
  useEffect(() => {
    formikProps.values.quantity_to_be_added = 0
    formikProps.values.notes = ""
    formikProps.values.receiving_item_tracking_numbers = []
    formikProps.setFieldTouched("quantity_to_be_added", 0)
    formikProps.setFieldTouched("notes", "")
    formikProps.setFieldTouched("receiving_item_tracking_numbers", [])
    if(open) {
      formikProps.item_hold = {}
      formikProps.add_to_event = false
      formikProps.setFieldTouched("item_hold", {})
      formikProps.setFieldTouched("add_to_event", false)
    }
  }, [open])

  const handleSave = () => {
    if(submitting) return
    setSubmitting(true)
    if(formikProps.values.add_to_receiving_list ) {
      formikProps.values.item_hold.total_count = formikProps.values.quantity_to_be_added
      fetchAPI(`/webapi/receiving_items/`, (json) => {
        if(json.error) {
          alert(json.error)
        }else {
          onSave()
        }
      }, {
        method: "POST",
        body: {
          receiving_item: {
            item_id: item.id,
            ordered: formikProps.values.quantity_to_be_added,
            notes: formikProps.values.notes,
          },
          add_to_event: formikProps.values.add_to_event,
          item_hold: formikProps.values.item_hold,
          receiving_item_tracking_numbers: formikProps.values.receiving_item_tracking_numbers.filter(x=>
            x.id || x.tracking_number
          )
        }
      })
    }else {
      fetchAPI(`/webapi/items/${item.id}/create_inventory_update/`, (json) => {
        if(json.error) {
          alert(json.error)
        }else {
          onSave()
        }
        setSubmitting(false)

      }, {
        method: "POST",
        body: {
          add_to_event: formikProps.values.add_to_event,
          item_hold: formikProps.values.item_hold,
          item_inventory_log: {
            count: 1 * formikProps.values.quantity_to_be_added,
            recieving_item: false,
          }
        }
      })
    }

  }

  const renderButtons = () => {
    return (
      <Stack direction="row" spacing={2} justifyContent="flex-end" className="mt-4">
        {renderCancelButton("Cancel", onClose)}
        {renderButton("Save", handleSave, {color:"green", disabled: isSubmitDisabled()})}
      </Stack>
    )
  }



  const isSubmitDisabled = () => {
    return !(formikProps.values.quantity_to_be_added && formikProps.values.quantity_to_be_added > 0)
  }

  const generateDefaultTrackingNumberObject = () => {
    return {
      tracking_number: "",
      status: "",
      courier: "",
      temporary_id: "temp-" + Math.random()* 100000000,
      tracking_data: {},
      tracking_response: {}
    }
  }
  return (
    <div className="mt-[40px]">
      <div className="max-w-[254px]">
        {renderTextField(
          "Quantity to be added",
          "quantity_to_be_added",
          {
            type: "number",
            min: 0,
            required: true,
            fieldProperties: {
              inputProps:{ min: 0 },
              min: 0,
              type: "number",
            }
          }
        )}
      </div>
      {isJaguar(user) && (
        <div>
          <div className="text-black">
            Any ordered item will have to go on the Warehouse Receiving List first.
            Only add directly to inventory if the item is physically at the Warehouse.
          </div>
            <div className="mt-2">
              {renderRadioField("add_to_receiving_list", [
                {label: "Add to Receiving List", value: true},
                {label: "Add to Inventory (Warehouse Only)", value: false}
              ])}
            </div>
        </div>
      )}
      {formikProps.values.add_to_receiving_list && (
        <>
          <a className="block my-2" href="javascript:void(0)" onClick={(e) => {
            formikProps.setFieldValue("receiving_item_tracking_numbers", [...formikProps.values.receiving_item_tracking_numbers, generateDefaultTrackingNumberObject()])
          }}>
            + Add Tracking Number
          </a>
          {formikProps.values.receiving_item_tracking_numbers.map((tracking_number, index) => {
            return (
              <div className="mt-2">
              <ReceivingListTrackingNumberForm
                key={"tracking-number-" + tracking_number.temporary_id}
                formikProps={formikProps}
                index={index}
              />
              </div>
            )
          })}
          {renderTextAreaField("Notes specific to Shipping/Receiving", "notes")}
          {renderCheckField("Add to Event (Optional)", "add_to_event", ['mb-0'])}
          {formikProps.values.add_to_event && (
            <ItemHoldFormRevised
              formikProps={formikProps}
              item={item}
              newItem={true}
            />
          )}
        </>
      )}
      {renderButtons()}
    </div>
  )

};

export default ItemAddForm;